import { Link } from "react-router-dom";
import { Building2, ArrowLeft } from "lucide-react";

export default function LegalNoticePage() {
  return (
    <div className="min-h-screen bg-[#050505] text-white" data-testid="legal-notice-page">
      {/* Header */}
      <div className="border-b border-white/[0.10] bg-[#050505]">
        <div className="max-w-3xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group">
            <img src="/equia-logo.png" alt="EQUIA Global Property" className="h-14 w-auto" />
          </Link>
          <Link
            to="/"
            data-testid="back-to-app-link"
            className="flex items-center gap-2 text-white/60 text-sm hover:text-[#D4AF37] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Back to App
          </Link>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-12">
        <p className="text-[11px] tracking-[0.15em] uppercase text-[#D4AF37] mb-3">Legal</p>
        <h1 className="font-serif text-4xl tracking-tight mb-2">Legal Notice</h1>
        <p className="text-white/65 text-sm mb-10">Impressum according to applicable regulations</p>

        <div className="space-y-8 text-white/90 text-sm leading-relaxed">
          {/* Company Information */}
          <section>
            <h2 className="font-serif text-xl text-white mb-4">Company Information</h2>
            <div className="bg-[#0A0A0A] border border-white/[0.10] p-6 space-y-3">
              <div className="flex justify-between border-b border-white/[0.08] pb-3">
                <span className="text-white/60 text-xs uppercase tracking-wider">Company Name</span>
                <span className="text-white font-medium">Education Punk Ltd.</span>
              </div>
              <div className="flex justify-between border-b border-white/[0.08] pb-3">
                <span className="text-white/60 text-xs uppercase tracking-wider">Street Address</span>
                <span className="text-white">Schweinauerstr. 58</span>
              </div>
              <div className="flex justify-between border-b border-white/[0.08] pb-3">
                <span className="text-white/60 text-xs uppercase tracking-wider">City / Postal Code</span>
                <span className="text-white">90439 N&uuml;rnberg</span>
              </div>
              <div className="flex justify-between border-b border-white/[0.08] pb-3">
                <span className="text-white/60 text-xs uppercase tracking-wider">Country</span>
                <span className="text-white">Germany</span>
              </div>
              <div className="flex justify-between border-b border-white/[0.08] pb-3">
                <span className="text-white/60 text-xs uppercase tracking-wider">Commercial Register</span>
                <span className="text-white">HRB 36765, Amtsgericht N&uuml;rnberg</span>
              </div>
              <div className="flex justify-between">
                <span className="text-white/60 text-xs uppercase tracking-wider">Managing Director</span>
                <span className="text-white">Jonas Brand</span>
              </div>
            </div>
          </section>

          {/* Contact */}
          <section>
            <h2 className="font-serif text-xl text-white mb-4">Contact</h2>
            <div className="bg-[#0A0A0A] border border-white/[0.10] p-6 space-y-3">
              <div className="flex justify-between border-b border-white/[0.08] pb-3">
                <span className="text-white/60 text-xs uppercase tracking-wider">Email</span>
                <a href="mailto:info@education-punk.de" className="text-white hover:text-[#D4AF37] transition-colors">info@education-punk.de</a>
              </div>
              <div className="flex justify-between">
                <span className="text-white/60 text-xs uppercase tracking-wider">Telephone</span>
                <a href="tel:+4991140088070" className="text-white font-mono hover:text-[#D4AF37] transition-colors">+49 911 400 880 70</a>
              </div>
            </div>
          </section>

          {/* Responsible for Content */}
          <section>
            <h2 className="font-serif text-xl text-white mb-4">Responsible for Content according to &sect; 55 Abs. 2 RStV</h2>
            <p>
              Responsible for the content of this website:
            </p>
            <div className="bg-[#0A0A0A] border border-white/[0.10] p-6 mt-3">
              <p className="text-white">Education Punk Ltd.</p>
              <p className="text-white/65 mt-1">Schweinauerstr. 58, 90439 N&uuml;rnberg, Germany</p>
            </div>
          </section>

          {/* Dispute Resolution */}
          <section>
            <h2 className="font-serif text-xl text-white mb-4">Dispute Resolution</h2>
            <p>
              The European Commission provides a platform for online dispute resolution (ODR):
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#D4AF37] hover:text-[#B5952F] ml-1 transition-colors">
                ec.europa.eu/consumers/odr
              </a>
            </p>
            <p className="mt-3">
              We are neither obligated nor willing to participate in dispute resolution proceedings before a consumer arbitration board.
            </p>
          </section>

          {/* Liability Disclaimer */}
          <section>
            <h2 className="font-serif text-xl text-white mb-4">Liability for Content</h2>
            <p>
              The contents of our pages were created with the greatest care. However, we cannot guarantee the accuracy, completeness, or timeliness of the content. As a service provider, we are responsible for our own content on these pages in accordance with general laws. However, we are not obligated to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-white mb-4">Liability for Links</h2>
            <p>
              Our offer contains links to external third-party websites over whose content we have no influence. Therefore, we cannot assume any liability for this external content. The respective provider or operator of the pages is always responsible for the content of the linked pages.
            </p>
          </section>
        </div>
      </div>

      {/* Page footer */}
      <div className="border-t border-white/[0.10] py-6">
        <div className="max-w-3xl mx-auto px-6 flex items-center justify-between">
          <p className="text-white/55 text-xs">&copy; {new Date().getFullYear()} EQUIA Global Property</p>
          <div className="flex items-center gap-6">
            <Link to="/legal" className="text-white/65 text-xs hover:text-[#D4AF37] transition-colors">Legal Notice</Link>
            <Link to="/privacy" className="text-white/65 text-xs hover:text-[#D4AF37] transition-colors">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
